<header class="header-area header-v1">
  <div
    class="header-navigation"
    [ngClass]="[visible ? '' : 'breakpoint-on', windowScrolled ? 'sticky' : '']"
    (window:resize)="detectHeader()"
  >
    <div class="container-fluid">
      <div class="row align-items-center">
        <!-- Brand Logo and Language Selection Dropdown -->
        <div class="col-xl-4 col-lg-5 col-md-5">
          <div class="site-branding-and-language-selection">
            <div class="brand-logo">
              <a routerLink="/">
                <img
                  src="assets/img/logo-zcaler.png"
                  class="img-fluid"
                  alt="Zscaler logo"
                  style="width: 130px"
                />
                <p class="text-white">|</p>
                <p class="lead text-white">ThreatLabz</p>
              </a>
            </div>
          </div>
        </div>
        <!-- Desktop and Mobile Menu -->
        <div class="col-xl-6 col-lg-5 col-md-1 text-center">
          <div class="primary-menu">
            <div class="nav-menu" [ngClass]="navMethod ? 'menu-on' : ''">
              <!-- Navbar Close Icon -->
              <div class="navbar-close" (click)="toggleNav()">
                <div class="cross-wrap">
                  <span class="top"></span><span class="bottom"></span>
                </div>
              </div>
              <nav class="main-menu">
                <ul class="">
                  <!-- Data -->
                  <li
                    class="ml-3"
                    [ngClass]="
                      item.child
                        ? 'menu-item menu-item-has-children'
                        : 'menu-item'
                    "
                    *ngFor="let item of navigation"
                  >
                    <a
                      href="javascript:void(0)"
                      *ngIf="item.child"
                      (click)="trigger(item)"
                      >{{ item.linkText }}</a
                    >
                    <span
                      class="dd-trigger"
                      *ngIf="item.child"
                      (click)="trigger(item)"
                      ><i class="fas fa-angle-down"></i
                    ></span>
                    <a routerLink="{{ item.link }}" *ngIf="!item.child">{{
                      item.linkText
                    }}</a>
                    <ul
                      style="cursor: none"
                      class="sub-menu border border-grey rounded shadow-sm"
                      *ngIf="item.child"
                      [ngClass]="item.open ? 'd-block' : ''"
                    >
                      <li
                        [ngClass]="
                          item.child
                            ? 'menu-item menu-item-has-children'
                            : 'menu-item'
                        "
                        *ngFor="let item of item.submenu"
                      >
                        <!-- <img *ngIf="item.image" [src]="item.imagelink" class="iconDetails"  alt="blog thumbnail one"> -->
                        <!-- <a href="javascript:void(0)" *ngIf="item.child"
                                                    (click)="trigger(item)">{{item.linkText}}</a>
                                                <span class="dd-trigger" *ngIf="item.child" (click)="trigger(item)"><i
                                                        class="fas fa-angle-down"></i></span> -->
                        <ng-container *ngIf="!item.extraLink">
                          <a
                            routerLink="{{ item.link }}"
                            *ngIf="!item.child"
                          >
                            <!-- <img *ngIf="item.image" class="imageHide" [src]="item.imagelink"
                                                        alt="blog thumbnail one"> -->
                            {{ item.linkText }}
                          </a>
                        </ng-container>
                        <ng-container *ngIf="item.extraLink">
                          <a
                            [href]="item.link"
                            target="_blank"
                            *ngIf="!item.child"
                          >
                            <!-- <img *ngIf="item.image" class="imageHide" [src]="item.imagelink"
                                                        alt="blog thumbnail one"> -->
                            {{ item.linkText }}
                          </a>
                        </ng-container>
                      </li>
                    </ul>
                  </li>
                  <!-- Data -->
                </ul>
              </nav>
            </div>
          </div>
        </div>
        <!-- Menu Right -->
        <div class="col-xl-2 col-lg-2 col-md-6">
          <div class="header-right text-white">
            <ul>
              <li>
                <div
                  class="menu-toggle text-white"
                  style="margin-right: 15px"
                  [ngClass]="navMethod ? 'active' : ''"
                >
                  <div
                    class="menu-overlay text-white"
                    (click)="toggleNav()"
                  ></div>
                  <!-- Navbar Toggler -->
                  <div class="nav-toggle">
                    <div
                      class="navbar-toggler float-end"
                      [ngClass]="navMethod ? 'active' : ''"
                      (click)="toggleNav()"
                    >
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <a
                  href="javascript:void(0)"
                  class="search-btn text-light"
                  (click)="openSearch(searchmodal)"
                  title="Search within site"
                  ><i
                    class="fal fa-search align-middle"
                    style="font-size: 25px"
                  ></i
                ></a>
              </li>
              <li>
                <!-- <a href="javascript:void(0)" 
                                title="{{ toggle2 ? 'Switch to dark mode' : 'Switch to light mode'}}" 
                                (click)="onChangeTheme()" 
                                style="font-size: 25px;margin-right: 15px;">
                                    <i [ngClass]="toggle2 ? 'far fa-moon' : 'far fa-sun'"></i></a> -->

                <!-- <div style="font-size: 25px;margin-right: 15px;" >
                                        <input type="checkbox" (click)="onChangeTheme()" 
                                         class="checkbox" id="checkbox">
                                      <label for="checkbox" class="label border border-grey"  title="{{ toggle2 ? 'Switch to dark mode' : 'Switch to light mode'}}" >
                                        <i class="fas fa-moon"></i>
                                        <i class='fas fa-sun'></i>
                                        <div class='ball shadow-lg'></div>
                                      </label>
                                    </div> -->
                <!-- <div class="headerButtonDKM" style="margin-right: 15px;">
                                    <label for="grayscale" class="firsLabelDKM">
                                        <input type="checkbox" id="grayscale" (click)="onChangeTheme()" 
                                        />
                                        <label  title=" {{toggle2 ? 'Switch to dark mode' : 'Switch to light mode' }}">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </label>
                                    </label>
                                </div> -->

                <div class="headerButtonDKM" style="margin-left: 15px">
                  <label
                    for="colored"
                    class="firsLabelDKM colored"
                    title=" {{
                      toggle2 ? 'Switch to dark mode' : 'Switch to light mode'
                    }}"
                  >
                    <input
                      type="checkbox"
                      id="colored"
                      (click)="onChangeTheme()"
                    />
                    <label>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </label>
                  </label>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
  </div>
  <!-- /.header-navigation -->
</header>
<ng-template #searchmodal let-modal>
  <app-search-box></app-search-box>
</ng-template>
